import React, { useMemo, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { API_URL } from '../auth/authMode';

const SetPassword = () => {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const token = params.get('token') || '';
    const purpose = params.get('purpose') || 'reset';
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [error, setError] = useState('');
    const [done, setDone] = useState(false);
    const [loading, setLoading] = useState(false);

    const title = useMemo(
        () => (purpose === 'invite' ? 'Set your password' : 'Reset password'),
        [purpose]
    );

    const onSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (password.length < 8) {
            setError('Password must be at least 8 characters');
            return;
        }
        if (password !== confirm) {
            setError('Passwords do not match');
            return;
        }
        setLoading(true);
        try {
            const endpoint = purpose === 'invite' ? '/auth/accept-invite' : '/auth/reset-password';
            const res = await fetch(`${API_URL}${endpoint}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, password, purpose }),
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.error || 'Failed to set password');
            setDone(true);
            setTimeout(() => navigate('/login', { replace: true }), 1500);
        } catch (err) {
            setError(err.message || 'Failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={pageStyle}>
            <form onSubmit={onSubmit} style={cardStyle}>
                <p style={eyebrowStyle}>ZasyaHR</p>
                <h1 style={{ margin: '8px 0 16px', fontSize: 26 }}>{title}</h1>
                {!token && <p style={{ color: '#b91c1c' }}>Missing token. Open the link from your email.</p>}
                {done ? (
                    <p style={{ color: '#166534' }}>Password saved. Redirecting to login…</p>
                ) : (
                    <>
                        <label style={labelStyle}>
                            New password
                            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required style={inputStyle} />
                        </label>
                        <label style={{ ...labelStyle, marginTop: 12 }}>
                            Confirm password
                            <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required style={inputStyle} />
                        </label>
                        {error && <p style={{ color: '#b91c1c', fontSize: 14 }}>{error}</p>}
                        <button type="submit" disabled={loading || !token} style={btnStyle}>
                            {loading ? 'Saving…' : 'Save password'}
                        </button>
                    </>
                )}
                <p style={{ marginTop: 16, fontSize: 13 }}>
                    <Link to="/login">Back to login</Link>
                </p>
            </form>
        </div>
    );
};

const pageStyle = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(160deg, #0f172a 0%, #1e293b 50%, #0f766e 100%)',
    padding: 24,
};
const cardStyle = {
    width: '100%',
    maxWidth: 400,
    background: 'rgba(255,255,255,0.96)',
    padding: '36px 32px',
    borderRadius: 4,
};
const eyebrowStyle = { margin: 0, letterSpacing: '0.12em', fontSize: 12, color: '#0f766e', textTransform: 'uppercase' };
const labelStyle = { display: 'block', fontSize: 13, color: '#334155', fontFamily: 'system-ui, sans-serif' };
const inputStyle = {
    display: 'block', width: '100%', marginTop: 6, padding: '10px 12px',
    border: '1px solid #cbd5e1', borderRadius: 6, boxSizing: 'border-box',
};
const btnStyle = {
    marginTop: 18, width: '100%', padding: '12px 14px', border: 'none', borderRadius: 6,
    background: '#0f766e', color: '#fff', fontWeight: 600, cursor: 'pointer',
};

export default SetPassword;
